export default "__VITE_ASSET__e0c9ff0a__"